<template>
  <v-row>
    <v-col cols="12">
      <Filtro/>
    </v-col>
    <v-col cols="12">
      <TableRetencao/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Retencao',

  components: {
    Filtro: () => import("./components/Filtro"),
    TableRetencao: () => import("./components/TableRetencao")
  }
}
</script>